import { makeStyles } from '@material-ui/core'

export const useLayoutStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(5),
  },
  projectInfo: {
    color: theme.palette.grey[500],
    textTransform: 'none',
  },
  title: {
    maxWidth: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))
